<template>
    <div class="mx-4 divide-y divide-gray-200">
        <div class="grid grid-cols-1 gap-x-4 gap-y-3 pb-2 pt-5 sm:grid-cols-3">
            <div></div>
            <div class="text-base font-semibold text-gray-700">
                {{ $t('experience_and_knowledge.knowledge') }}
            </div>
            <div class="text-center text-base font-semibold text-gray-700">
                {{ $t('experience_and_knowledge.experience') }}
            </div>
        </div>
        <ExperienceAndKnowledgeRow
            v-model:experience="formValues.stocks_equity_funds_experience"
            v-model:knowledge="formValues.stocks_equity_funds_knowledge"
            name="experience_and_knowledge.stocks_equity_funds"
            :label="$t('experience_and_knowledge.stocks_equity_funds')"></ExperienceAndKnowledgeRow>
        <ExperienceAndKnowledgeRow
            v-model:experience="formValues.mixed_funds_etfs_experience"
            v-model:knowledge="formValues.mixed_funds_etfs_knowledge"
            name="experience_and_knowledge.mixed_funds_etfs"
            :label="$t('experience_and_knowledge.mixed_funds_etfs')"></ExperienceAndKnowledgeRow>
        <ExperienceAndKnowledgeRow
            v-model:experience="formValues.bonds_bond_funds_experience"
            v-model:knowledge="formValues.bonds_bond_funds_knowledge"
            name="experience_and_knowledge.bonds_bond_funds"
            :label="$t('experience_and_knowledge.bonds_bond_funds')"></ExperienceAndKnowledgeRow>
        <ExperienceAndKnowledgeRow
            v-model:experience="formValues.closed_ended_funds_experience"
            v-model:knowledge="formValues.closed_ended_funds_knowledge"
            name="experience_and_knowledge.closed_ended_funds"
            :label="$t('experience_and_knowledge.closed_ended_funds')"></ExperienceAndKnowledgeRow>
        <ExperienceAndKnowledgeRow
            v-model:experience="formValues.options_other_derivatives_experience"
            v-model:knowledge="formValues.options_other_derivatives_knowledge"
            name="experience_and_knowledge.options_other_derivatives"
            :label="$t('experience_and_knowledge.options_other_derivatives')"></ExperienceAndKnowledgeRow>
        <ExperienceAndKnowledgeRow
            v-model:experience="formValues.venture_capital_experience"
            v-model:knowledge="formValues.venture_capital_knowledge"
            name="experience_and_knowledge.venture_capital"
            :label="$t('experience_and_knowledge.venture_capital')"></ExperienceAndKnowledgeRow>
        <ExperienceAndKnowledgeRow
            v-model:experience="formValues.other_shares_loans_in_private_companies_experience"
            v-model:knowledge="formValues.other_shares_loans_in_private_companies_knowledge"
            name="experience_and_knowledge.other_shares_loans_in_private_companies"
            :label="$t('experience_and_knowledge.other_shares_loans_in_private_companies')"></ExperienceAndKnowledgeRow>
        <ExperienceAndKnowledgeRow
            v-model:experience="formValues.other_alternative_investments_experience"
            v-model:knowledge="formValues.other_alternative_investments_knowledge"
            name="experience_and_knowledge.other_alternative_investments"
            :label="$t('experience_and_knowledge.other_alternative_investments')"></ExperienceAndKnowledgeRow>

        <div class="grid grid-cols-1 px-2 py-6">
            <BaseInputSelect
                v-model="formValues.follow_market_prices_business_financial_news"
                name="experience_and_knowledge.follow_market_prices_business_financial_news"
                :options="investmentFollowMarketOptions"
                :label="$t('experience_and_knowledge.follow_market_prices_business_financial_news')"></BaseInputSelect>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted } from 'vue'
import { TaxResidency } from '../../../../../utilities/account/useAccountDataPersonal'
import { FollowMarketOption } from '../../../../../typings'
import { i18n } from '../../../../../localization'
import BaseInputSelect from '../../../../base/BaseInputSelect.vue'
import ExperienceAndKnowledgeRow from '../../form/ExperienceAndKnowledgeRow.vue'
import { useVModel } from '@vueuse/core'
import { useForm } from 'vee-validate'
import { getNaturalWidgetFormValidationRules } from '../../form/forms'
import { useLegalAccountFormState } from '../../../../../utilities/account/useAccountFormLegal'

const props = defineProps<{
    modelValue: TaxResidency[]
}>()
const emit = defineEmits(['update:modelValue'])

const formValues = useVModel(props, 'modelValue', emit)

const investmentFollowMarketOptions = computed(() => {
    return Object.keys(FollowMarketOption).map((key) => {
        return {
            key: key,
            label: i18n.global.t('follow_market_options.' + FollowMarketOption[key]),
        }
    })
})

const formState = useLegalAccountFormState()

const form = useForm({
    validationSchema: getNaturalWidgetFormValidationRules('experience_and_knowledge'),
})

onMounted(() => {
    // @ts-ignore
    formState.currentForm = form
})
onUnmounted(() => {
    formState.currentForm = null
})
</script>
